var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogout = function SvgLogout(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.973 14.667h-5.98A.665.665 0 0 1 1.329 14V2c0-.368.297-.667.664-.667h5.98c.367 0 .664-.298.664-.667S8.34 0 7.973 0h-5.98A2 2 0 0 0 0 2v12a2 2 0 0 0 1.993 2h5.98c.367 0 .664-.298.664-.667s-.297-.666-.664-.666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.802 7.525-4.04-4c-.261-.259-.681-.257-.939.004s-.256.684.004.943l.002.002 2.887 2.858H5.983a.666.666 0 0 0 0 1.333h7.734l-2.887 2.858a.67.67 0 0 0-.009.943.66.66 0 0 0 .939.009l.002-.002 4.04-4a.67.67 0 0 0 .006-.943l-.006-.006z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export default ForwardRef;